import { addDays, parseCalendarDate, startOfBusinessDate } from '@nudool/shared';

/** The ISO instant a picked `YYYY-MM-DD` starts as a Pacific business day, `dayOffset` days on. */
export function startOfPickedDay(ymd: string, dayOffset = 0): string {
  return startOfBusinessDate(addDays(parseCalendarDate(ymd), dayOffset)).toISOString();
}
